import { App } from "./classes/App";
import { translator } from "@shop/frontend/web/js/services/TranslatorService";

const app = new App();

translator.getLanguages().then(() => {
	app.init({});
});
